import React from "react";
import PropTypes from "prop-types";
import {
  ContentBlock,
  Label,
  Input,
} from "@onelogin/react-components";

const FormField = ({ fieldId, fieldLabel, value, onChange }) => (
  <ContentBlock>
    <Label forId={fieldId}>
      {fieldLabel}
    </Label>
    <Input
      // Couldn't get autoFocus to work for whatever reason
      id={fieldId}
      name={fieldId}
      value={value}
      onChange={onChange}
      size="large"
      data-testid={`${fieldId}-field`}
    />
  </ContentBlock>
);

FormField.propTypes = {
  fieldId: PropTypes.string.isRequired,
  fieldLabel: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default FormField;
